// extracted by mini-css-extract-plugin
export var container = "Console-module--container--qZ2XP";
export var center = "Console-module--center--D525+";
export var info = "Console-module--info--5KxCu";
export var icon = "Console-module--icon--wNb7e";